<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-body main-card-body">
        <h3
          class="uppercase text-center"
          style="
            color: #0064b2;
            font-family: 'Times new roman';
            font-weight: bold;
          "
        > WELCOME TO THE GOVERNANCE OF COVID-19 SAFETY REGISTRATION AND DECLARATION PROGRAM
        </h3>
        <el-collapse  @change="handleChange" v-model="mData.dataDefault.activeNameT" class="mt-5 ml-3">
          <div class="collapse-cus collapse-passport">
            <img class="tick passport-tick" src="img/tick.png" alt="" v-if="mData.havePassport">
            <img id="passport_arrow" class="arrow" src="img/arrow.png" alt="">
            <el-collapse-item title="Passport" name="passport" class="passport">
              <div
                class="d-flex justify-content-center"
                style="flex-direction: column"
                v-if="!mData.havePassport"
              >
                <h5 class="text-center">You don't have Passport</h5>
              </div>
              <div v-if="mData.havePassport">
                <b-row>
                  <b-col xl="6" lg="12" md="12">
                    <div class="passport-image">
                      <el-image
                        style="width: 100%;"
                        :src="mData.dataDefault.anhPassport"
                        fit="cover"></el-image>
                    </div>
                  </b-col>
                  <b-col xl="6" lg="12" md="12">
                    <el-collapse v-model="mData.dataDefault.activeName">
                      <el-collapse-item class="passport-information" title="Passport information" name="Passport-information">
                        <el-form label-position="top">
                          <div class="row">
                            <!-- <div class="col-md-3 col-12">
                              <el-form-item label="Type">
                                <el-input
                                  v-model="
                                    mData.dataDefault.dataPassport.ho_chieu.loai
                                  "
                                  disabled
                                ></el-input>
                              </el-form-item>
                            </div> -->
                            <div class="col-md-4 col-12">
                              <el-form-item label="Code">
                                <el-input
                                  v-model="
                                    mData.dataDefault.dataPassport.ho_chieu.ma_so
                                  "
                                  disabled
                                ></el-input>
                              </el-form-item>
                            </div>
                            <div class="col-md-8 col-12">
                              <el-form-item label="Passport No.">
                                <el-input
                                  v-model="
                                    mData.dataDefault.dataPassport.ho_chieu
                                      .so_ho_chieu
                                  "
                                  disabled
                                ></el-input>
                              </el-form-item>
                            </div>
                            <div class="col-12">
                              <el-form-item label="Fullname">
                                <el-input
                                  v-model="
                                    mData.dataDefault.dataPassport.ho_chieu.ho_ten
                                  "
                                  disabled
                                ></el-input>
                              </el-form-item>
                            </div>
                            <div class="col-md-6 col-12">
                              <el-form-item label="Nationality">
                                <el-select
                                  v-model="
                                    mData.dataDefault.dataPassport.ho_chieu
                                      .quoc_tich_id
                                  "
                                  disabled
                                >
                                  <el-option
                                    v-for="item in mData.dataDefault
                                      .nationalityList"
                                    :key="item.id"
                                    :label="
                                      item.ten_quoc_tich && item.ten_quoc_tich.en
                                        ? item.ten_quoc_tich.en
                                        : ''
                                    "
                                    :value="item.id"
                                  >
                                  </el-option>
                                </el-select>
                              </el-form-item>
                            </div>
                            <div class="col-md-6 col-12">
                              <el-form-item label="Date of birth">
                                <el-date-picker
                                  v-model="
                                    mData.dataDefault.dataPassport.ho_chieu
                                      .ngay_sinh
                                  "
                                  type="date"
                                  disabled
                                  :format="aElement.datepicker.formatDate"
                                  :valueFormat="aElement.datepicker.valueFormat"
                                >
                                </el-date-picker>
                              </el-form-item>
                            </div>
                            <!-- <div class="col-12">
                              <el-form-item label="Place of birth">
                                <el-input
                                  v-model="
                                    mData.dataDefault.dataPassport.ho_chieu
                                      .noi_sinh
                                  "
                                  disabled
                                ></el-input>
                              </el-form-item>
                            </div> -->
                            <div class="col-md-6 col-12">
                              <el-form-item label="Sex">
                                <el-radio
                                  v-model="
                                    mData.dataDefault.dataPassport.ho_chieu
                                      .gioi_tinh
                                  "
                                  :label="1"
                                  disabled
                                  class="mr-2"
                                  >Male</el-radio
                                >
                                <el-radio
                                  v-model="
                                    mData.dataDefault.dataPassport.ho_chieu
                                      .gioi_tinh
                                  "
                                  :label="2"
                                  disabled
                                  class="mr-2"
                                  >Female</el-radio
                                >
                                <el-radio
                                  v-model="
                                    mData.dataDefault.dataPassport.ho_chieu
                                      .gioi_tinh
                                  "
                                  :label="4"
                                  disabled
                                  class="mr-2"
                                  >Other</el-radio
                                >
                              </el-form-item>
                            </div>
                            <!-- <div class="col-md-6 col-12">
                              <el-form-item label="Id card No.">
                                <el-input
                                  v-model="
                                    mData.dataDefault.dataPassport.ho_chieu.cmnd
                                  "
                                  disabled
                                ></el-input>
                              </el-form-item>
                            </div>
                            <div class="col-md-6 col-12">
                              <el-form-item label="Date of issue">
                                <el-date-picker
                                  v-model="
                                    mData.dataDefault.dataPassport.ho_chieu
                                      .ngay_cap
                                  "
                                  type="date"
                                  disabled
                                  :format="aElement.datepicker.formatDate"
                                  :valueFormat="aElement.datepicker.valueFormat"
                                >
                                </el-date-picker>
                              </el-form-item>
                            </div> -->
                            <div class="col-md-6 col-12">
                              <el-form-item label="Date of expiry">
                                <el-date-picker
                                  v-model="
                                    mData.dataDefault.dataPassport.ho_chieu
                                      .hieu_luc_den
                                  "
                                  type="date"
                                  disabled
                                  :format="aElement.datepicker.formatDate"
                                  :valueFormat="aElement.datepicker.valueFormat"
                                >
                                </el-date-picker>
                              </el-form-item>
                            </div>
                            <!-- <div class="col-12">
                              <el-form-item label="Place of issue">
                                <el-input
                                  v-model="
                                    mData.dataDefault.dataPassport.ho_chieu
                                      .noi_cap
                                  "
                                  disabled
                                ></el-input>
                              </el-form-item>
                            </div> -->
                          </div>
                        </el-form>
                      </el-collapse-item>
                    </el-collapse>
                  </b-col>
                </b-row>
              </div>
            </el-collapse-item>
          </div>
          
          <div class="collapse-cus collapse-selfie">
            <img class="tick" src="img/tick.png" alt="" v-if="mData.haveSelfie">
            <img id="selfie_arrow" class="arrow" src="img/arrow.png" alt="">
            <el-collapse-item title="Selfie photo" name="selfie" class="selfie-photo" >
              <div
                class="d-flex justify-content-center"
                style="flex-direction: column"
                v-if="!mData.haveSelfie"
              >
                <h5 class="text-center">You don't have any Selfie photo</h5>
              </div>
              <div v-if="mData.haveSelfie">
                <el-upload
                  id="selfie-upload"
                  list-type="picture-card"
                  action
                  :show-file-list="false"
                  :auto-upload="false"
                  :limit="mData.fileUploadOption.AnhSelfies.limit"
                  :accept="mData.fileUploadOption.AnhSelfies.accept"
                  :on-change="fn_uploadChangeAnhSelfies"
                >
                  <i slot="default" class="el-icon-plus"></i>
                </el-upload>
                <div class="selfie-image">
                  <b-row>
                    <b-col md="4" sm="6" cols="12">
                      <el-image
                      style="width: 100%;"
                      :src="mData.dataDefault.anhSelfie"
                      fit="cover"></el-image>
                    </b-col>
                    <b-col md="4" sm="6" cols="12" v-for="item in mData.dataDefault.anhSelfiesURL" :key="item.url">
                      <div class="p-relative">
                        <el-image
                          style="width: 100%;"
                          :src="item.url"
                          fit="cover">
                        </el-image>
                        
                        <el-tooltip class="item" effect="dark" content="Click to remove photo" placement="top-end">
                          <div class="remove-icon c-ponit" @click="fn_uploadRemoveAnhSelfies(item.id)">
                            <el-image
                              style="width: 100%;"
                              src="img/remove_icon.png"
                              fit="cover">
                            </el-image>
                          </div>
                        </el-tooltip>
                      </div>
                    </b-col>
                  </b-row>
                </div>
              </div>
              
            </el-collapse-item>
          </div>
          
          <div class="collapse-cus collapse-vaccination">
            <img class="tick vaccination-tick" src="img/tick.png" alt="" v-if="mData.haveVaccination">
            <img id="vaccination_arrow" class="arrow" src="img/arrow.png" alt="">
            <el-collapse-item title="Vaccination certificate" name="vaccination" class="vaccination-certificate">
              <div
                class="d-flex justify-content-center"
                style="flex-direction: column"
                v-if="!mData.haveVaccination"
              >
                <h5 class="text-center">You don't have any Vaccination certificate</h5>
              </div>
              <div v-if="mData.haveVaccination">
                <el-upload
                  id="vaccination-upload"
                  v-if="mData.havePermissionUploadVaccination"
                  list-type="picture-card"
                  action
                  :show-file-list="false"
                  :auto-upload="false"
                  :limit="mData.fileUploadOption.AnhVaccinations.limit"
                  :accept="mData.fileUploadOption.AnhVaccinations.accept"
                  :on-change="fn_uploadChangeAnhVaccinations"
                >
                  <i slot="default" class="el-icon-plus"></i>
                </el-upload>
                <div class="vaccination-image">
                  <b-row>
                    <b-col md="6" cols="12">
                      <el-image
                      style="width: 100%;"
                      :src="mData.dataDefault.anhVaccination"
                      fit="cover"></el-image>
                    </b-col>
                    <b-col md="6" cols="12" v-for="item in mData.dataDefault.anhVaccinationsURL" :key="item.url">
                      <div class="p-relative">
                        <el-image
                        style="width: 100%;"
                        :src="item.url"
                        fit="cover"></el-image>

                        <el-tooltip class="item" effect="dark" content="Click to remove photo" placement="top-end">
                          <div v-if="mData.havePermissionUploadVaccination" class="remove-icon c-ponit" @click="fn_uploadRemoveVaccinations(item.id)">
                            <el-image
                              style="width: 100%;"
                              src="img/remove_icon.png"
                              fit="cover">
                            </el-image>
                          </div>
                        </el-tooltip>
                      </div>
                    </b-col>
                  </b-row>
                </div>
              </div>
              
            </el-collapse-item>
          </div>
          
          <div class="collapse-cus collapse-qr">
            <img class="tick" src="img/tick.png" alt="" v-if="mData.haveQR">
            <img id="qr_arrow" class="arrow" src="img/arrow.png" alt="">
            <el-collapse-item title="QR Code" name="qr" class="qr-code">
              <div
                class="d-flex justify-content-center"
                style="flex-direction: column"
                v-if="!mData.checkHaveQR"
              >
                <h5 class="text-center">You don't have any QR code</h5>
              </div>
              <b-row>
                <b-col md="12" v-if="mData.checkShowQr" class="mb-3">
                  <div
                    class="d-flex justify-content-center"
                    style="flex-direction: column; align-items: center;"
                  >
                    <div @click="fn_showModalQrCertificate(mData.dataDefault.data.qr,mData.dataDefault.data.qr)">
                      <QrCode
                        :text="
                        mData.dataDefault.data && mData.dataDefault.data.qr
                            ? mData.dataDefault.data.qr
                            : ''
                        "
                      />
                    </div>
                    <h4 class="mt-3 id-name">
                        {{
                        mData.dataDefault.data && mData.dataDefault.data.qr
                            ? mData.dataDefault.data.qr
                            : ""
                        }}
                    </h4>
                  </div>
                </b-col>
                <b-col md="12" v-if="mData.checkShowQrVaccination" class="mb-3">
                  <div
                    class="d-flex justify-content-center"
                    style="flex-direction: column; align-items: center;"
                  >
                    <div @click="fn_showModalQrCertificate(mData.dataDefault.data.khai_bao.tiem_chung.qr,'Vaccination certificate')">
                      <QrCode
                        :text="
                          mData.dataDefault.data && 
                          mData.dataDefault.data.khai_bao && 
                          mData.dataDefault.data.khai_bao.tiem_chung && 
                          mData.dataDefault.data.khai_bao.tiem_chung.qr ? mData.dataDefault.data.khai_bao.tiem_chung.qr : ''
                        "
                      />
                    </div>
                    <h4 class="mt-3 id-name">
                        Vaccination certificate
                    </h4>
                  </div>
                </b-col>
                <b-col md="12" v-for="item in mData.dataDefault.arrQrTestCertificate" :key="item.id" class="mb-3">
                  <div
                    class="d-flex justify-content-center"
                    style="flex-direction: column; align-items: center;"
                    v-if="mData.checkShowQrTestCretificate"
                  >
                    <div @click="fn_showModalQrCertificate(item.qr_code,item.ngay_xet_nghiem)">
                      <QrCode
                        :text="item.qr_code ? item.qr_code : ''"
                      />
                    </div>
                    <h4 class="mt-3 id-name">
                      Test date {{item.ngay_xet_nghiem | dateFormat}}
                    </h4>
                  </div>
                </b-col>
                <b-col md="12"  v-if="mData.checkShowQrHistory">
                  <div class="text-center">
                    <el-link class="link-qr" type="primary" @click="fn_submitForm()">QR provision history</el-link>
                  </div>
                </b-col>
              </b-row>
            </el-collapse-item>
          </div>

          <div class="collapse-cus collapse-history-qr">
            <img id="wallet-qr_arrow" class="arrow" src="img/arrow.png" alt="">
            <el-collapse-item title="Wallet QR" name="wallet-qr" class="wallet-qr-code">
              <div
                class="d-flex justify-content-center"
                style="flex-direction: column"
                v-if="!mData.checkHaveQRWallet"
              >
                <h5 class="text-center">You don't have any QR code</h5>
              </div>
              <b-row class="mb-3" v-if="mData.checkHaveQRWallet">
                  <b-col xl="3" lg="4" md="6" class="mb-3">
                      <div
                          class="d-flex justify-content-center"
                          style="flex-direction: column; align-items: center;"
                      >
                          <div @click="fn_showModalQrCertificate(mData.dataDefault.data.qr,mData.dataDefault.data.qr)">
                          <QrCode
                              :text="
                              mData.dataDefault.data && mData.dataDefault.data.qr
                                  ? mData.dataDefault.data.qr
                                  : ''
                              "
                          />
                          </div>
                          <h4 class="mt-3 id-name">
                              {{
                              mData.dataDefault.data && mData.dataDefault.data.qr
                                  ? mData.dataDefault.data.qr
                                  : ""
                              }}
                          </h4>
                      </div>
                  </b-col>

                  <b-col xl="3" lg="4" md="6" v-for="item in mData.dataDefault.arrQrTestCertificateWallet" :key="item.id" class="mb-3">
                      <div
                          class="d-flex justify-content-center"
                          style="flex-direction: column; align-items: center;"
                      >
                          <div @click="fn_showModalQrCertificate(item.qr_code,item.ngay_xet_nghiem)">
                              <QrCode
                                  :text="item.qr_code ? item.qr_code : ''"
                              />
                          </div>
                          <h4 class="mt-3 id-name">
                              Test date {{item.ngay_xet_nghiem | dateFormat}}
                          </h4>
                      </div>
                  </b-col>

                  <b-col  xl="3" lg="4" md="6" class="mb-3" v-if="mData.checkShowQrVaccinationWallet">
                      <div
                          class="d-flex justify-content-center"
                          style="flex-direction: column; align-items: center;"
                      >
                          <div @click="fn_showModalQrCertificate(mData.dataDefault.data.khai_bao.tiem_chung.qr,'Vaccination certificate')">
                              <QrCode
                                  :text="
                                      mData.dataDefault.data && 
                                      mData.dataDefault.data.khai_bao && 
                                      mData.dataDefault.data.khai_bao.tiem_chung && 
                                      mData.dataDefault.data.khai_bao.tiem_chung.qr ? mData.dataDefault.data.khai_bao.tiem_chung.qr : ''
                                  "
                              />
                          </div>
                          <h4 class="mt-3 id-name">
                              Vaccination certificate
                          </h4>
                      </div>
                  </b-col>
              </b-row>
            </el-collapse-item>
          </div>


          <!-- <div class="text-left mb-3 wallet-qr" @click="fn_submitForm()">
            <span>
              Wallet QR
            </span>
            <el-button
              class="btn-submit"
              @click="fn_submitForm()"
              icon="el-icon-postcard"
              v-ladda
              round
            >QR provision history
            </el-button>
          </div> -->
        </el-collapse>
      </div>
    </div>
    <el-dialog title="Detail" width="33%" :visible.sync="showModalQrCertificate">
      <div class="qr-certificate">
        <QrCode
          :size="1000"
          error-level="L"
          :text="this.qrTestCertificate"
        />
        <h4 class="mt-3 mb-3 id-name">
          {{ this.qrText }}
        </h4>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ForeignerQrApi from "../../../moduleApi/ForeignerQrApi";
import QuocGiaApi from "../../../moduleApi/QuocGiaApi";
import LanguageService from "../../../service/LanguageService";
import MethodService from "../../../service/MethodService";
import ExtensionService from "../../../service/ExtensionService";
import ForeignerApi from "../../../moduleApi/ForeignerApi";
import QrCode from "vue-qrcode-component";
import * as moment from 'moment';

export default {
  components: { QrCode },
  filters: {
    dateFormat: function (value) {
      let format = "DD/MM/YYYY";
      if (!value) return ''
      return moment(value).format(format);
    }
  },
  data() {
    return {
      aLang: LanguageService.lang,
      aElement: MethodService.element,
      currentUser: JSON.parse(localStorage.getItem('currentUser')),
      mData: {
        havePassport: false,
        haveSelfie: false,
        haveVaccination: false,
        haveQR: false,
        checkHaveQR: false,
        havePermissionUploadVaccination: false,
        checkShowQr: false,
        checkShowQrVaccination: false,
        checkShowQrTestCretificate: false,
        checkShowQrHistory: false,
        checkShowQrVaccinationWallet: false,
        checkShowQrTestCretificateWallet: false,
        checkHaveQRWallet: false,
        dataDefault: {
          dataInfo: null,
          arrQrTestCertificate: [],
          arrQrTestCertificateWallet: [],
          listQuocGia: [],
          listKBYTTiepXuc: [],
          listKBYTBenh: [],
          listVaccine: [],
          nationalityList: [],
          anh: "",
          data: null,
          qr: "",
          activeName: 'Passport-information',
          activeNameT: "passport",
          dataPassport: {
            anh_chan_dung_id: null,
            ho_chieu: {
              loai: "",
              ma_so: "",
              ho_ten: "",
              quoc_tich_id: "",
              ngay_sinh: null,
              so_ho_chieu: "",
              noi_sinh: "",
              gioi_tinh: null,
              cmnd: "",
              ngay_cap: null,
              hieu_luc_den: null,
              noi_cap: "",
            },
          },
          anhSelfie: "",
          anhVaccination:"",
          anhSelfies: [],
          anhVaccinations:[],
          anhSelfiesURL:[],
          anhVaccinationsURL: [],
          anhPassport: "",
          dialogReject: false,
          dialogApprove: false,
          blockButton: true,
          dialogImageUrl: '',
          dialogVisible: false,
          disabled: false,
        },
        dataForm: {
            y_te: {
              danh_sach_quoc_gia_da_den: "",
              danh_sach_dau_hieu: "",
              danh_sach_tiep_xuc: "",
              danh_sach_benh: "",
              than_nhiet: "",
            },
            tiem_chung: {
              luot_tiem: [
                {
                  thoi_gian_tiem: null,
                  dia_diem_tiem: "",
                },
              ],
              vaccine: "",
              gia_tri_den: null,
              so_giay_chung_nhan: "",
              anh_id: "",
              qr: "",
              link: "",
            },
            loai: "",
        },
        validForm: {},
        fileUploadOption: {
          Anh: {
            limit: 1,
            accept: ".jpg, .png, .jpeg",
            dialogImageUrl: "",
            dialogVisible: false,
            fileList: [],
          },
          AnhSelfies: {
            limit: 100,
            accept: ".jpg, .png, .jpeg",
            dialogAnhSelfiesImageUrl: "",
            dialogAnhSelfiesVisible: false,
            fileList: [],
          },
          AnhVaccinations: {
            limit: 100,
            accept: ".jpg, .png, .jpeg",
            dialogAnhVaccinationsImageUrl: "",
            dialogAnhVaccinationsVisible: false,
            fileList: [],
          },
        },
      },
      qrTestCertificate: "",
      qrText: "",
      showModalQrCertificate: false,
      selfieUploadLoading: false,
      vaccinationUploadLoading: false,
      vals: [],
      isOpenQrWallet: false
    };
  },
  methods: {
    fn_showModalQrCertificate(qr,text){
      this.showModalQrCertificate = true;
      this.qrTestCertificate = qr;
      if(text == "Vaccination certificate"){
        this.qrText = text;
      }else if(text.substring(0, 3) === "TP-"){
        this.qrText = text;
      }else{
        this.qrText = this.fn_formatterDate(text);
      }
      console.log("this.qrText",this.qrText);
    },
    fn_formatterDate(value) {
      let format = "DD/MM/YYYY";
      if (!value) return ''
      return moment(value).format(format);
    },
    async initData() {
      let quocGiaRes = await QuocGiaApi.list();
      this.mData.dataDefault.listQuocGia = quocGiaRes.result;
      let vietNam = this.mData.dataDefault.listQuocGia.find(maQG => maQG.ma.alpha_2 == "VN");
      let currentUser = MethodService.getCurrentUser();
      this.mData.dataDefault.arrQrTestCertificate = [];
      let passportData = await ForeignerApi.findById(currentUser.id);
      if(passportData.result){
        this.mData.havePassport = true;
        this.mData.haveSelfie = true;
        console.log("passportData.result",passportData.result);
        this.mData.dataDefault.dataPassport = passportData.result;
        this.mData.dataDefault.dataInfo = passportData.result.ho_chieu;
        this.mData.dataDefault.anhPassport = ExtensionService.urlImg + passportData.result.ho_chieu.anh_id;
        this.mData.dataDefault.anhSelfie = ExtensionService.urlImg + passportData.result.anh_chan_dung_id;
        if(passportData.result.anh_chan_dung_ids && passportData.result.anh_chan_dung_ids.length > 0){
          this.mData.dataDefault.anhSelfies = passportData.result.anh_chan_dung_ids;
          passportData.result.anh_chan_dung_ids.forEach(e => this.mData.dataDefault.anhSelfiesURL.push({
            id: e,
            url : window.MyConfig.hostApi + "file/thumb?id=" + e
          }))
        }
        try {
          let res = await ForeignerQrApi.list({
            filters: "trang_thai:nin:da_xuat_canh,khong_hop_le",
          });
          if (res.result && res.result.length > 0) {
            if(res.result[0].khai_bao.tiem_chung.anh_id){
              this.mData.haveVaccination = true;
              this.mData.dataDefault.anhVaccination = window.MyConfig.hostApi + "file/thumb?id=" + res.result[0].khai_bao.tiem_chung.anh_id;
            }
            if(res.result[0].trang_thai != "da_nhap_canh"){
              this.mData.havePermissionUploadVaccination = true;
            }
            this.mData.dataDefault.data = res.result[0];
            if(res.result[0].khai_bao.tiem_chung.anh_ids && res.result[0].khai_bao.tiem_chung.anh_ids.length > 0){
              this.mData.dataDefault.anhVaccinations = res.result[0].khai_bao.tiem_chung.anh_ids;
              res.result[0].khai_bao.tiem_chung.anh_ids.forEach(e => this.mData.dataDefault.anhVaccinationsURL.push({
                  id: e,
                  url : window.MyConfig.hostApi + "file/thumb?id=" + e
                }))
            }
            if (
                this.mData.dataDefault.data.trang_thai &&
                ["da_nhap_canh"].includes(this.mData.dataDefault.data.trang_thai)
            ) {
              this.mData.haveQR = true;
            }
            if (
                this.mData.dataDefault.data.trang_thai &&
                [
                "cho_cap_visa",
                "cho_nhap_visa",
                "cho_nhap_canh",
                "da_nhap_canh",
                ].includes(this.mData.dataDefault.data.trang_thai)
            ) {
                
              this.mData.checkHaveQR = true;
              this.mData.checkShowQr = true;
            }
            if (
                this.mData.dataDefault.data.trang_thai &&
                ["cho_nhap_canh","da_nhap_canh"].includes(this.mData.dataDefault.data.trang_thai)
            ) {
              this.mData.checkShowQrTestCretificate = true;
              this.mData.checkShowQrVaccination = true;
            }
            console.log("this.mData.dataDefault.data",this.mData.dataDefault.data);
            if(res.result[0].xet_nghiem){
              let arrQrTestCertificateAproved = res.result[0].xet_nghiem.filter(e => {
                return e.quoc_gia_id == vietNam.id || e.duoc_duyet === true || e.anh_id == null;
              })
              if(arrQrTestCertificateAproved.length > 0){
                let arrQrTestCertificateSort = arrQrTestCertificateAproved.sort(function(a,b) { 
                    return new Date(a.ngay_xet_nghiem).getTime() - new Date(b.ngay_xet_nghiem).getTime() 
                });
                this.mData.dataDefault.arrQrTestCertificate.push(arrQrTestCertificateAproved[arrQrTestCertificateSort.length -1]);
              }
              // if(res.result[0].xet_nghiem.length <= 5){
              //   this.mData.dataDefault.arrQrTestCertificate = res.result[0].xet_nghiem;
              // }else{
              //   this.mData.dataDefault.arrQrTestCertificate = res.result[0].xet_nghiem.slice(res.result[0].xet_nghiem.length - 5, res.result[0].xet_nghiem.length);
              //   console.log("this.mData.dataDefault.arrQrTestCertificate",this.mData.dataDefault.arrQrTestCertificate);
              // }
              
            }else{
              this.mData.dataDefault.arrQrTestCertificate = [];
            }
            if(this.mData.dataDefault.arrQrTestCertificate.length > 0){
              this.mData.checkShowQrTestCretificate = true;
              this.mData.checkShowQrVaccination = false;
              this.mData.checkHaveQR = true;
              this.mData.checkShowQr = false;
              this.mData.checkShowQrHistory = true;
            }else if(
              [
                "cho_cap_visa",
              ].includes(this.mData.dataDefault.data.trang_thai) &&
              this.mData.dataDefault.data.khai_bao.tiem_chung.anh_id != null
            ){
              this.mData.checkShowQrTestCretificate = false;
              this.mData.checkShowQrVaccination = false;
              this.mData.checkHaveQR = true;
              this.mData.checkShowQr = true;
              this.mData.checkShowQrHistory = true;
            }else if(
            [
              "cho_cap_visa",
              "cho_nhap_visa",
              "cho_nhap_canh",
              "da_nhap_canh",
            ].includes(this.mData.dataDefault.data.trang_thai)){
              this.mData.checkShowQrTestCretificate = false;
              this.mData.checkShowQrVaccination = true;
              this.mData.checkHaveQR = true;
              this.mData.checkShowQr = false;
              this.mData.checkShowQrHistory = true;
            }
            else{
              this.mData.checkShowQrTestCretificate = false;
              this.mData.checkShowQrVaccination = false;
              this.mData.checkHaveQR = true;
              this.mData.checkShowQr = true;
              this.mData.checkShowQrHistory = true;
            }
          } 
          if(
            [
              "cho_cap_visa",
            ].includes(this.mData.dataDefault.data.trang_thai) &&
            this.mData.dataDefault.data.khai_bao.tiem_chung.anh_id != null
          ){
            this.mData.checkHaveQRWallet = true;
            this.mData.checkShowQrTestCretificateWallet = true;
            this.mData.checkShowQrVaccinationWallet = false;
          }
          else if (
              this.mData.dataDefault.data.trang_thai &&
              [
              "cho_cap_visa",
              "cho_nhap_visa",
              "cho_nhap_canh",
              "da_nhap_canh"
              ].includes(this.mData.dataDefault.data.trang_thai)
          ) {
              this.mData.checkHaveQRWallet = true;
              this.mData.checkShowQrTestCretificateWallet = true;
              this.mData.checkShowQrVaccinationWallet = true;
          }else if (
            this.mData.dataDefault.data.trang_thai &&
            [
            "cho_duyet_vaccine",
            "dang_khai_bao"
            ].includes(this.mData.dataDefault.data.trang_thai)
          ) {
            this.mData.checkHaveQRWallet = true;
          }else{
            this.mData.checkHaveQRWallet = false;
          }
          if(res.result[0].xet_nghiem){
            let arrQrTestCertificateAproved = res.result[0].xet_nghiem.filter(e => {
              return e.duoc_duyet === true || e.quoc_gia_id == vietNam.id || (e.anh_id == null);
            })
            if(arrQrTestCertificateAproved.length > 0){
              let arrQrTestCertificateWalletSort = arrQrTestCertificateAproved.sort(function(a,b) { 
                  return new Date(a.ngay_xet_nghiem).getTime() - new Date(b.ngay_xet_nghiem).getTime() 
              });
              console.log("ưẻwẻwẻwẻwrưetdhbdfggha4ikuthtil  U21Q3HIK",arrQrTestCertificateWalletSort);
              this.mData.dataDefault.arrQrTestCertificateWallet = arrQrTestCertificateWalletSort.reverse();
            }
          }else{
            this.mData.dataDefault.arrQrTestCertificateWallet = [];
          }
          if(this.mData.dataDefault.arrQrTestCertificateWallet.length > 0){
            this.mData.checkHaveQRWallet = true;
          }
          console.log('mData.dataDefault.data',this.mData.dataDefault.data);
        } catch (error) {
          this.mData.haveQR = false;
          this.mData.checkHaveQR = false;
        }
        setTimeout(() =>{
          this.checkEnoughPhotos();
        },100)
      }
    },
    handleChange(val) {
      let ids = ["passport","selfie","vaccination","qr","wallet-qr"];
      ids.forEach(id => {
        document.getElementById(id+"_arrow").classList.remove("arrow-rotate");
      })
      if(val && val.length > 0){
        console.log("val",val);
        val.forEach(e => {
          document.getElementById(e+"_arrow").classList.add("arrow-rotate");
        })
      }
      this.isOpenQrWallet =false;
    },
    async getNationalityList() {
      const nationality = await QuocGiaApi.list();
      this.mData.dataDefault.nationalityList = nationality.result;
    },
    async checkIdCard(id) {
      try {
        let response = await ForeignerApi.verifyFace(
          this.mData.dataDefault.dataInfo.anh_id,
          id
        );
        const data = response.result ? JSON.parse(response.result) : {};
        if (data.verify_result != 0) {
          return true;
        }
        return false;
      } catch (err) {
        console.log("err xác thực cmnd", err);
        return false;
      }
    },
    //upload ảnh
    fn_uploadCheckFileSize(file) {
      return MethodService.checkFileSize(file, 3);
    },
    //Upload ảnh Selfie
    async fn_uploadRemoveAnhSelfies(fileId) {
      this.mData.dataDefault.anhSelfies =  this.mData.dataDefault.anhSelfies.filter(e => e != fileId);
      let data = {};
      data.id = this.currentUser.id;
      data.anh_chan_dung_ids = this.mData.dataDefault.anhSelfies;
      await ForeignerApi.updateRemoveSelfiePhoto(data);
      this.resetForm();
      this.initData();
    },
    async fn_uploadChangeAnhSelfies(file, fileList) {
      this.selfieUploadLoading = true;
      if(this.mData.dataDefault.anhSelfies.length == 3){
        toastr.info(
          `Only upload max 3 files`
        );
        return;
      }
      ExtensionService.upload(file, "foreignerSelfie")
        .then(async (res) => {
          let dataCard = await this.checkIdCard(res.result);
          if (!dataCard) {
            toastr.error("Please upload your selfie photo");
            // this.selfieUploadLoading = false;
            $.each(fileList, (i, el) => {
              if (el.uid == file.uid) {
                fileList.splice(i, 1);
              }
            });
            return;
          }
          this.mData.dataDefault.anhSelfies.push(res.result);
          this.mData.dataDefault.anhSelfiesURL.push({url : window.MyConfig.hostApi + "file/thumb?id=" + res.result});
          let data = {};
          data.id = this.currentUser.id;
          data.anh_chan_dung_ids = this.mData.dataDefault.anhSelfies;
          await ForeignerApi.update(data);
          this.resetForm();
          this.initData();
          // this.selfieUploadLoading = false;
        })
        .catch((error) => {
          toastr.error("An error occurred!");
          // this.selfieUploadLoading = false;
          $.each(fileList, (i, el) => {
            if (el.uid == file.uid) {
              fileList.splice(i, 1);
            }
          });
        });
    },

    //Upload ảnh Vaccination
    async fn_uploadRemoveVaccinations(fileId) {
      this.mData.dataDefault.anhVaccinations =  this.mData.dataDefault.anhVaccinations.filter(e => e != fileId);
      let data = {};
      data.id = this.mData.dataDefault.data.id;
      data.khai_bao = {
        tiem_chung:{
          anh_ids : this.mData.dataDefault.anhVaccinations
        }
      }
      await ForeignerQrApi.updateRemoveVaccinationCertificate(data);
      this.resetForm();
      this.initData();
    },
    async fn_uploadChangeAnhVaccinations(file, fileList) {
      // this.mData.dataDefault.uploading = true;
      if(this.mData.dataDefault.anhVaccinations.length == 1){
        toastr.info(
          `Only upload max 1 file`
        );
        return
      }
      ExtensionService.upload(file, "foreignerVaccinations")
        .then(async (res) => {
          this.mData.dataDefault.anhVaccinations.push(res.result);
          this.mData.dataDefault.anhVaccinationsURL.push({url : window.MyConfig.hostApi + "file/thumb?id=" + res.result});
          let data = {};
          data.id = this.mData.dataDefault.data.id;
          data.khai_bao = {
            tiem_chung:{
              anh_ids : this.mData.dataDefault.anhVaccinations
            }
          }
          await ForeignerQrApi.updateVaccinationCertificate(data);
          this.resetForm();
          this.initData();
        })
        .catch((error) => {
          toastr.error("An error occurred!");
          // this.mData.dataDefault.uploading = false;
          $.each(fileList, (i, el) => {
            if (el.uid == file.uid) {
              fileList.splice(i, 1);
            }
          });
        });
    },
    resetForm(){
      this.mData.dataDefault.anhSelfies=[];
      this.mData.dataDefault.anhSelfiesURL = [];
      this.mData.dataDefault.anhVaccinations=[];
      this.mData.dataDefault.anhVaccinationsURL = [];
    },
    checkActivecollapse(){
      let val = ["passport"];
      this.handleChange(val);
    },
    checkEnoughPhotos(){
      let selfie = document.getElementById("selfie-upload");
      let vaccination = document.getElementById("vaccination-upload");
      if(this.mData.dataDefault.anhSelfies.length == 3){
        selfie.classList.add("hide");
      }else{
        selfie.classList.remove("hide");
      }
      if(this.mData.dataDefault.anhVaccinations.length == 1){
        vaccination.classList.add("hide");
      }else{
        if(vaccination){
          vaccination.classList.remove("hide");
        }
      }
    },
    fn_submitForm(){
      this.mData.dataDefault.activeNameT = "wallet-qr";
      // window.location.href="/admin/QrWallet";
      // this.$router.push({
      //               name: "Admin-QrWallet"
      //           });
      // this.vals = ["wallet-qr"];
      // this.isOpenQrWallet = true;
      // this.handleChange(this.vals);
    }
  },
  async mounted() {
    this.$store.commit("fn_checkChangePassword");
    this.initData();
    await this.getNationalityList();
    this.checkActivecollapse();
  },
};
</script>

<style lang="scss" scoped>
@font-face {
  font-family: UTM-Cafeta;
  src: url(/fonts/UTM_Cafeta.ttf);
}
@font-face {
  font-family: MYRIADPRO-REGULAR;
  src: url(/fonts/MYRIADPRO-REGULAR.OTF);
}
@import url('https://fonts.googleapis.com/css2?family=Roboto:wght@700&display=swap');
.hide {
  ::v-deep.el-upload.el-upload--text {
    display: none;
  }
}
::v-deep .passport .el-collapse-item__arrow,
::v-deep .selfie-photo .el-collapse-item__arrow,
::v-deep .vaccination-certificate .el-collapse-item__arrow,
::v-deep .qr-code .el-collapse-item__arrow,
::v-deep .wallet-qr-code .el-collapse-item__arrow{
  visibility: hidden;
}
::v-deep .passport-information .el-collapse-item__arrow{
  visibility: visible;
}
.hide{
  display: none;
}
.p-relative{
  position: relative;
}
.remove-icon{
  position: absolute;
  top: 5px;
  right: 5px;
  max-width: 20px;
  height:20px;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  border-radius: 10px;
}
.c-ponit:hover{
  cursor: pointer;
}
.collapse-cus {
  position:relative;
}
.tick{
  position:absolute;
  top: 8px;
  right: 32px;
  pointer-events: none;
}
// .passport-tick{
//   right: 50px;
// }
.arrow{
  position:absolute;
  top: 8px;
  right: 15px;
  pointer-events: none;
}

.arrow-rotate{
  transform: rotate(-90deg);
  transition-duration: 0.3s;
}
.el-collapse{
  border: none;
}
.el-collapse-item{
  margin-bottom: 20px;
}

.collapse-passport{
  max-width: 135px;
}
.collapse-selfie{
  max-width: 160px;
}
.collapse-vaccination{
  max-width: 235px;
}
.collapse-qr{
  max-width: 130px;
}
.collapse-history-qr{
  max-width: 130px;
}
.selfie-image{
  max-width: 605px;
}
.vaccination-image{
  max-width: 650px;
}

::v-deep .el-collapse-item__header{
  max-width: 500px;
  height: 35px;
  background-color: #fff;
  border: 1px solid #a9c9e2;
  border-radius: 10px;
  font-size: 15.5px;
  color: #0c66ad;
  font-family: 'Roboto', sans-serif;
}
::v-deep .el-collapse-item__wrap{
  margin-top: 15px;
  border-bottom: none;
}
::v-deep .passport-information .el-collapse-item__header{
  max-width: 100%;
  height: 40px;
  line-height: 40px;
  background-color: #f5f7fa;
  border: 1px solid #f5f7fa;
  border-radius: 0;
  color: #0c66ad;
  font-size: 14px;
  text-indent: 10px;
  font-weight: 400;
}
::v-deep .el-collapse-item__content{
  border-radius: 10px;
  border-bottom: 1px solid #ebeef5;
}
::v-deep .passport .el-collapse-item__wrap{
  width: 1040px;
  max-width: 1040px;
}
::v-deep .passport-information .el-collapse-item__wrap{
  width: 100% !important;
  margin-top:0;
}
::v-deep .passport-information .el-collapse-item__content{
  border-radius: 0;
  border-bottom: 1px solid #ebeef5;
}
::v-deep .selfie-photo .el-collapse-item__wrap{
  width: 680px;
  max-width: 680px;
}
::v-deep .vaccination-certificate .el-collapse-item__wrap{
  width: 720px;
  max-width: 720px;
}
::v-deep .qr-code .el-collapse-item__wrap{
  width: 350px;
  max-width: 350px;
}
::v-deep .qr-code .el-collapse-item__content{
  padding: 30px;
}
::v-deep .collapse-history-qr .el-collapse-item__wrap{
  width: 1300px;
  max-width: 1300px;
}
::v-deep .collapse-history-qr .el-collapse-item__content{
  padding: 30px;
}
::v-deep .selfie-photo .el-collapse-item__content,
::v-deep .vaccination-certificate .el-collapse-item__content{
  position: relative;
}
::v-deep  .el-upload--picture-card{
  width: 30px;
  height: 30px;
  position: absolute;
  border: 1px solid #0c66ad;
  top: 10px;
  right: 10px;
  border-radius: 30px;
}
::v-deep  .el-upload--picture-card  i{
  position: absolute;
  top: 5px;
  right: 5px;
  font-size: 18px;
  color: #0c66ad;
  font-weight: 600;
}
::v-deep .el-form-item__label{
  color: #0c66ad;
  font-family: MYRIADPRO-REGULAR;
  font-weight: 600;
}
::v-deep img {
  object-fit: contain;
  object-position: center;
}
.main-card-body{
  position: relative;
  top: 10px;
}
.card-body {
  min-height: 86vh;
}
.wallet-qr{
  width: 100px;
  max-width: 130px;
  height: 35px;
  background-color: #fff;
  border: 1px solid #a9c9e2;
  border-radius: 10px;
  font-size: 15.5px;
  padding: 5px 5px 5px 10px;
  color: #0c66ad;
  font-family: 'Roboto', sans-serif;
}
.wallet-qr:hover{
  cursor: pointer;
}
::v-deep .link-qr{
  color: #0c66ad !important;
  font-weight: bold;
  text-decoration: underline !important;
}
::v-deep .link-qr:hover{
  color: #06ace9 !important;
  font-weight: bold;
  text-decoration: none !important;
}
@media (max-width: 1625px) {
  .id-name{
    font-size: 18px;
  }
  ::v-deep .collapse-history-qr .el-collapse-item__wrap{
    width: 1000px;
  }
}
@media (max-width: 1323px) {
  .id-name{
    font-size: 17px;
  }
  ::v-deep .collapse-history-qr .el-collapse-item__wrap{
    width: 850px;
  }
}
@media (max-width: 1366px) {
  ::v-deep .el-dialog.el-dialog--center{
    width: 40% !important;
  }
}
@media (max-width: 1244px) {
  .id-name{
    font-size: 16px;
  }
}
@media (max-width: 1200px) {
  ::v-deep .collapse-history-qr .el-collapse-item__wrap{
    width: 600px;
  }
}
@media (max-width: 1015px) {
  ::v-deep .el-dialog.el-dialog--center{
    width: 60% !important;
  }
}
@media (max-width: 1360px) {
  ::v-deep .passport .el-collapse-item__wrap{
    width: 800px;
  }
}
@media (max-width: 1120px) {
  ::v-deep .passport .el-collapse-item__wrap{
    width: 600px;
  }
  ::v-deep .vaccination-certificate .el-collapse-item__wrap{
    width: 650px;
  }
  .vaccination-image{
    max-width: 580px;
  }
  .id-name{
    font-size: 15px;
  }
}
@media (max-width: 990px) {
  ::v-deep .el-dialog.el-dialog--center{
    width: 60% !important;
  }
  .id-name{
    font-size: 17px;
  }
}
@media (max-width: 767px) {
  ::v-deep .selfie-photo .el-collapse-item__wrap{
    width: 580px;
  }
  .selfie-image{
    max-width: 480px;
  }
  ::v-deep .vaccination-certificate .el-collapse-item__wrap{
    width: 590px;
  }
  .vaccination-image{
    max-width: 510px;
  }
  .id-name{
    font-size: 17px;
  }
}
@media (max-width: 650px) {
  ::v-deep .passport .el-collapse-item__wrap{
    width: 450px;
  }
  ::v-deep .selfie-photo .el-collapse-item__wrap{
    width: 450px;
  }
  .selfie-image{
    max-width: 380px;
  }
  ::v-deep .vaccination-certificate .el-collapse-item__wrap{
    width: 450px;
  }
  .vaccination-image{
    max-width: 380px;
  }
  .id-name{
    font-size: 17px;
  }
  ::v-deep .collapse-history-qr .el-collapse-item__wrap{
    width: 450px;
  }
}
@media (max-width: 500px) {
  ::v-deep .passport .el-collapse-item__wrap{
    width: 350px;
  }
  ::v-deep .selfie-photo .el-collapse-item__wrap{
    width: 350px;
  }
  .selfie-image{
    max-width: 280px;
  }
  ::v-deep .vaccination-certificate .el-collapse-item__wrap{
    width: 350px;
  }
  .vaccination-image{
    max-width: 280px;
  }
  ::v-deep .collapse-history-qr .el-collapse-item__wrap{
    width: 350px;
  }
}
@media (max-width: 400px) {
  ::v-deep .passport .el-collapse-item__wrap{
    width: 260px;
  }
  ::v-deep .selfie-photo .el-collapse-item__wrap{
    width: 260px;
  }
  .selfie-image{
    max-width: 190px;
  }
  ::v-deep .vaccination-certificate .el-collapse-item__wrap{
    width: 240px;
  }
  .vaccination-image{
    max-width: 170px;
  }
  ::v-deep .qr-code .el-collapse-item__wrap{
    width: 250px;
  }
  ::v-deep .collapse-history-qr .el-collapse-item__wrap{
    width: 240px;
  }
}
@media (max-width: 300px) {
  ::v-deep .passport .el-collapse-item__wrap{
    width: 220px;
  }
  ::v-deep .qr-code .el-collapse-item__wrap{
    width: 220px;
  }
  ::v-deep .selfie-photo .el-collapse-item__wrap{
    width: 220px;
  }
  .selfie-image{
    max-width: 150px;
  }
  ::v-deep .vaccination-certificate .el-collapse-item__wrap{
    width: 220px;
  }
  .vaccination-image{
    max-width: 150px;
  }
  ::v-deep .collapse-history-qr .el-collapse-item__wrap{
    width: 200px;
  }
}
@media (max-width: 670px) {
  ::v-deep .el-dialog.el-dialog--center{
    width: 90% !important;
  }
}
@media (max-width: 448px) {
  ::v-deep .el-dialog.el-dialog--center{
    width: 95% !important;
  }
}
@media (max-width: 390px) {
  
}


.qr-certificate{
  display: flex;
  justify-content: center;
  margin: 20px 0;
  flex-direction: column; 
  align-items: center;
}
::v-deep .qr-certificate div img{
  width: 500px;
}
@media (max-width: 1650px) {
    ::v-deep .el-dialog{
        width: 40% !important;
    }
    ::v-deep .qr-certificate div img{
        width: 450px;
    }
    .qr-certificate h4{
        font-size: 21px;
    }
}

@media (max-width: 1300px) {
    ::v-deep .el-dialog{
        width: 42% !important;
    }
    ::v-deep .qr-certificate div img{
        width: 370px;
    }
    .qr-certificate h4{
        font-size: 20px;
    }
}

@media (max-width: 990px) {
    ::v-deep .el-dialog{
        width: 50% !important;
    }
    ::v-deep .qr-certificate div img{
        width: 290px;
    }
    .qr-certificate h4{
        font-size: 19px;
    }
}
@media (max-width: 650px) {
    ::v-deep .el-dialog{
        width: 57% !important;
    }
    ::v-deep .qr-certificate div img{
        width: 270px;
    }
    .qr-certificate h4{
        font-size: 18px;
    }
}

@media (max-width: 500px) {
    ::v-deep .el-dialog{
        width: 73% !important;
    }
    ::v-deep .qr-certificate div img{
        width: 270px;
    }
    .qr-certificate h4{
        font-size: 17px;
    }
}

@media (max-width: 400px) {
    ::v-deep .qr-certificate div img{
        width: 220px;
    }
    .qr-certificate h4{
        font-size: 16px;
    }
}

@media (max-width: 310px) {
    ::v-deep .qr-certificate div img{
        width: 190px;
    }
    .qr-certificate h4{
        font-size: 14px;
    }
}
</style>